angular.module('gym.mobile_app').factory('LoadDebouncePendingAccessRequestsService', ["$q", "MobileApp", function($q, MobileApp) {
  var loadDebounced;
  loadDebounced = _.debounce((function(deferred) {
    return MobileApp.all('access_requests').doGET('pending_count').then(function(data) {
      return deferred.resolve(data.pending_count);
    }, function(data) {
      return deferred.reject(data);
    });
  }), 1000);
  return {
    load: function() {
      var deferred;
      deferred = $q.defer();
      loadDebounced(deferred);
      return deferred.promise;
    }
  };
}]);
